import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getFormSchemaData = async (name) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/form-schema/${name}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getFixedFormSchemaData = async (name) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/form-schema/fixed/${name}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
